import apiService from '../api'

export interface StockReference {
  id: string
  batchNumber?: string | null
  bookingNumber?: string | null
  containerNumber?: string | null
  product?: string | null
  location?: string | null
  warehouse?: string | null
  status?: string | null
}

export async function getStockReferences(): Promise<StockReference[]> {
  const response = await apiService.get<{
    success: boolean
    data: { rows: StockReference[] }
  }>('/inventory/stock-references')
  const data = (response as any)?.data ?? response
  return data.rows ?? []
}
